import { render, staticRenderFns } from "./HomeStartJourney.vue?vue&type=template&id=45c1a83f&scoped=true"
import script from "./HomeStartJourney.vue?vue&type=script&lang=js"
export * from "./HomeStartJourney.vue?vue&type=script&lang=js"
import style0 from "./HomeStartJourney.vue?vue&type=style&index=0&id=45c1a83f&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "45c1a83f",
  null
  
)

export default component.exports